var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4583 0C5.13021 0 0 5.13021 0 11.4583C0 17.7865 5.13021 22.9167 11.4583 22.9167C17.7865 22.9167 22.9167 17.7865 22.9167 11.4583C22.9167 5.13021 17.7865 0 11.4583 0ZM16.425 9.52083C16.5165 9.41629 16.5861 9.29452 16.6298 9.16267C16.6735 9.03083 16.6904 8.89158 16.6794 8.75311C16.6685 8.61464 16.63 8.47975 16.5662 8.35638C16.5024 8.23301 16.4146 8.12365 16.3079 8.03473C16.2012 7.94581 16.0777 7.87913 15.9449 7.83861C15.812 7.79809 15.6724 7.78454 15.5343 7.79878C15.3961 7.81301 15.2622 7.85474 15.1404 7.92149C15.0186 7.98825 14.9113 8.07869 14.825 8.1875L10.3458 13.5615L8.02812 11.2427C7.83166 11.053 7.56854 10.948 7.29542 10.9503C7.02229 10.9527 6.76103 11.0623 6.5679 11.2554C6.37476 11.4485 6.26521 11.7098 6.26284 11.9829C6.26047 12.256 6.36546 12.5192 6.55521 12.7156L9.68021 15.8406C9.78256 15.9429 9.9051 16.0228 10.04 16.0751C10.1749 16.1274 10.3193 16.151 10.4638 16.1444C10.6084 16.1379 10.75 16.1012 10.8796 16.0369C11.0092 15.9726 11.124 15.882 11.2167 15.7708L16.425 9.52083Z",
    fill: "#2D9CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.997df9a0c4f8cf23f70becac423e9a8e.svg";
export { ForwardRef as ReactComponent };